import moment from 'moment';
export function dateFormatter(date){

    const localTime = moment.utc(date).local().format('DD-MM-YYYY');
    return localTime;
}